// import axios from 'axios'
// import constants from '../../../helpers/constants'
// import { isEqual } from '@/helpers/isEqual'

export default {
  namespaced: true,
  state: {
    formData: {},
    formDataErrors: {},
    isAnotherRecipient: false,
    isOpen: true,
    pending: true
  },
  getters: {
    isRecipientFormValid (state) {
      if (state.isAnotherRecipient) {
        const arrayOfErrors = Object.values(state.formDataErrors)
        const errorsStr = arrayOfErrors.reduce((acc, curr) => acc + curr, '')
        return !errorsStr.length
      }
      return true
    }
  },
  mutations: {
    SET_RECIPIENT (state, data) {
      state.isAnotherRecipient = data
      // localStorage.setItem('isAnotherRecipient', JSON.stringify(state.isAnotherRecipient))
    },
    SET_PENDING (state, data) {
      state.pending = data
    },
    SET_OPEN (state, data) {
      state.isOpen = data
    },
    SET_DATA (state, data) {
      state.formData = { ...state.formData, ...data }
      localStorage.setItem('recipientNewData', JSON.stringify(state.formData))
    },
    SET_ERRORS (state, data) {
      state.formDataErrors = { ...state.formDataErrors, ...data }
    }
  },
  actions: {
    SET_IS_ANOTHER_RECIPIENT ({ commit }, data) {
      commit('SET_RECIPIENT', data)
    },
    SET_RECIPIENT_PENDING ({ commit }, data) {
      commit('SET_PENDING', data)
    },
    SET_RECIPIENT_IS_OPEN ({ commit }, data) {
      commit('SET_OPEN', data)
    },
    SET_RECIPIENT_DATA ({ commit }, data) {
      commit('SET_DATA', data)
    },
    SET_RECIPIENT_ERRORS ({ commit }, data) {
      commit('SET_ERRORS', data)
    }
  }
}
